import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { postNotice } from "../api/notice";
import { NoticePostParams } from "../types/types";
import { useSnackbar } from "notistack";

const usePostNotice = ({
  contents,
  title,
  part,
  writer_idx,
  area,
}: NoticePostParams) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation({
    mutationFn: () =>
      postNotice({ contents, title, part, writer_idx, area }),

    onSuccess: (data) => {
      navigate(-1);
      enqueueSnackbar(data.message, {
        variant: "success",
      });
      localStorage.removeItem("noticeImages");
    },
  });
  return mutation;
};

export default usePostNotice;
